import { create } from "zustand";
import { immer } from "zustand/middleware/immer";
import type { ToastData } from "@/actions/entities/toast.type";

interface ToastStore {
  toasts: ToastData[];

  show: (data: Omit<ToastData, "id">, prepend?: boolean) => void;
  dismiss: (id: string) => void;
  dismissAll: () => void;
}

const useToastStore = create<ToastStore>()(
  immer((set) => ({
    toasts: [],
    show(data, prepend = false) {
      set((state) => {
        const uuid = Date.now().toString();

        if (prepend) {
          state.toasts.unshift({ ...data, id: uuid });
        } else {
          state.toasts.push({ ...data, id: uuid });
        }
      });
    },
    dismiss(id) {
      set((state) => {
        const index = state.toasts.findIndex((t) => t.id === id);

        state.toasts.splice(index, 1);
      });
    },
    dismissAll() {
      set({ toasts: [] });
    },
  })),
);

export default useToastStore;
